import {
  alias,
  arrayOf as arrayType,
  bool as boolType,
  number as numberType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

export const dataModel = {
  clientOnlyProduct: alias('product')
    .params({ itemId: stringType().isRequired(), dataSource: stringType() })
    .shape(shapeType({
      dataSources: stringType(),
      identifiers: shapeType({
        itemId: stringType(),
        isSuperSku: boolType(),
        parentId: stringType(),
        sampleId: stringType()
      }),
      specificationGroup: arrayType(shapeType({
        specifications: arrayType(shapeType({
          specName: stringType(),
          specValue: stringType()
        })),
        specTitle: stringType()
      }))
    })),
  products: params({ itemIds: arrayType(stringType().isRequired()).isRequired() })
    .arrayOf(shapeType({
      identifiers: shapeType({
        itemId: stringType(),
        sampleId: stringType()
      }),
    })),
  sampleProduct: alias('product')
    .params({ itemId: stringType().isRequired(), dataSource: stringType() })
    .shape(shapeType({
      availabilityType: shapeType({
        discontinued: boolType()
      }),
      dataSources: stringType(),
      identifiers: shapeType({
        itemId: stringType()
      }),
      fulfillment: params({ storeId: stringType(), zipCode: stringType() }).shape({
        fulfillmentOptions: arrayType(shapeType({
          fulfillable: boolType()
        }))
      }),
      pricing: params({ storeId: stringType() }).shape({
        value: numberType({ float: true })
      }),
      specificationGroup: arrayType(shapeType({
        specifications: arrayType(shapeType({
          specName: stringType(),
          specValue: stringType()
        })),
        specTitle: stringType()
      }))
    })),
  sampleProducts: alias('products')
    .params({ itemIds: arrayType(stringType().isRequired()).isRequired() })
    .arrayOf(shapeType({
      availabilityType: shapeType({
        discontinued: boolType()
      }),
      identifiers: shapeType({
        itemId: stringType()
      }),
      fulfillment: params({ storeId: stringType(), zipCode: stringType() }).shape({
        fulfillmentOptions: arrayType(shapeType({
          fulfillable: boolType()
        }))
      }),
      media: shapeType({
        images: arrayType(shapeType({
          sizes: arrayType(stringType()),
          subType: stringType(),
          url: stringType()
        }))
      }),
      pricing: params({ storeId: stringType() }).shape({
        value: numberType({ float: true })
      }),
      specificationGroup: arrayType(shapeType({
        specifications: arrayType(shapeType({
          specName: stringType(),
          specValue: stringType()
        })),
        specTitle: stringType()
      }))
    })),
  sampleProductsMetadata: alias('metadata').params({ parentId: stringType().isRequired() }).shape({
    attributes: arrayType(shapeType({
      attributeName: stringType(),
      attributeValues: arrayType(shapeType({
        value: stringType()
      }))
    })),
    childItemsLookup: arrayType(shapeType({
      itemId: stringType(),
      attributeCombination: stringType()
    }))
  })
};